import { FunctionComponent } from 'preact';

import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { useIcons } from '../../hooks/useIcons';

export const CloseButton: FunctionComponent<IconButtonProps> = (props) => {
  const { Cancel } = useIcons();
  return (
    <IconButton {...props}>
      <Cancel />
    </IconButton>
  );
};
